import { Stack } from '@mui/material';
import { bindTrigger, anchorRef, PopupState } from 'material-ui-popup-state/hooks';

import { SearchForm, FilterButton, isFiltersSelected } from '@occc/ui-design-system';

export type AdSetsListActionsProps = {
  search: string;
  status: string;
  filterPopupState: PopupState;
  onSearchSubmit: (values: { search: string }) => void;
};

export const AdSetsListActions = ({
  search,
  status,
  filterPopupState,
  onSearchSubmit,
}: AdSetsListActionsProps) => {
  const handleSearchSubmit = (values: { search?: string }) => {
    onSearchSubmit({ search: values.search || '' });
  };

  return (
    <Stack direction='row' alignItems='center' gap={1}>
      <SearchForm onSubmit={handleSearchSubmit} initialValues={{ search }} key={search} />
      <FilterButton
        {...bindTrigger(filterPopupState)}
        ref={anchorRef(filterPopupState)}
        showBadge={isFiltersSelected([status], [''])}
      />
    </Stack>
  );
};
